import React from 'react'

import './modal.scss'


export default function TimerModal({timerEnd, onSetTimerEnd, username, timerTimoutRef}) {
    const [now, setNow] = React.useState(new Date())
    const value = Math.max(0, Math.round((timerEnd - new Date()) / 1000))

    React.useEffect(() => {
        function update() {
            setNow(new Date())
            const value = Math.max(0, Math.round((timerEnd - new Date()) / 1000))

            if (value <= 0) {
                clearInterval(i)
                setTimeout(() => {
                    onSetTimerEnd(null)
                }, 1000)
            }

        }
        const i = setInterval(update, 100)
        return () => {
            clearInterval(i)
            clearTimeout(timerTimoutRef.current)
        }
    }, [timerEnd])

    return <span className="timer">{value}</span>
}


export function makeSound(username) {
    function bing() {
        const audioContext = new (window.AudioContext || window.webkitAudioContext)();

          // Create a GainNode for volume control
          const gainNode = audioContext.createGain();
          gainNode.gain.setValueAtTime(0.3, audioContext.currentTime); // Set initial volume

          // Connect the GainNode to the audio context destination (speakers)
          gainNode.connect(audioContext.destination);

          // Function to create and play an oscillator at a given frequency
          const playOscillator = (frequency, type, duration, startTime) => {
            const oscillator = audioContext.createOscillator();
            oscillator.type = type; // 'sine', 'triangle', etc.
            oscillator.frequency.setValueAtTime(frequency, audioContext.currentTime); // Set frequency
            oscillator.connect(gainNode); // Connect to the GainNode
            oscillator.start(audioContext.currentTime + startTime); // Start the oscillator
            oscillator.stop(audioContext.currentTime + startTime + duration); // Stop after the duration
          };

          // Play a soft chord (C Major: C, E, G)
          playOscillator(261.63, 'sine', 2, 0); // C4
          playOscillator(329.63, 'sine', 2, 0); // E4
          playOscillator(392.00, 'sine', 2, 0); // G4

          // Optional: Add a gentle fade-out
          gainNode.gain.exponentialRampToValueAtTime(0.0001, audioContext.currentTime + 2); // Fade out by the end of 2 seconds
    }
    bing()
    setTimeout(bing, 500)
    setTimeout(bing, 1000)

    if (username === 'Ania' && Math.random() < 0.05) {
        setTimeout(playILoveYou, 2000)
    }
}

function playILoveYou() {
    const utterance = new SpeechSynthesisUtterance("I love you")
    window.speechSynthesis.speak(utterance)
}
